import React from 'react';
import {Nav} from "../../components/Nav/Nav";

export const Home = () => {
    return (
        <>

            <Nav />
            <body>
            <div className="container mt-5">
                {/* Row for Name/Title and Image */}
                <div className="row align-items-center">
                    {/* Left Column - Name and Title */}
                    <div className="col-md-7 text-center text-md-start">
                        <h1>Marc E. Canby</h1>
                        <p className="lead">Ph.D. Candidate, Computer Science, University of Illinois Urbana-Champaign</p>

                        <div className="icon-links mt-3">

                            {/* Email */}
                            <a href="mailto:marc.canby@gmail.com" className="me-3" title="Mail">
                                <i className="fas fa-envelope" style={{ fontSize: '1.75rem' }}></i>
                            </a>

                            {/* Google Scholar */}
                            <a href="https://scholar.google.com/citations?user=zHzMaCsAAAAJ&hl=en" target="_blank" rel="noopener noreferrer" className="me-3" title="Google Scholar">
                                <i className="fas fa-graduation-cap" style={{ fontSize: '1.75rem' }}></i>
                            </a>

                            {/* Semantic Scholar */}
                            <a href="https://www.semanticscholar.org/author/Marc-E.-Canby/51515137" target="_blank" rel="noopener noreferrer" className="me-3" title={"Semantic Scholar"}>
                                <i className="fas fa-book" style={{ fontSize: '1.75rem' }}></i>
                            </a>

                            {/* GitHub */}
                            <a href="https://github.com/marccanby" target="_blank" rel="noopener noreferrer" className="me-3" title="Github">
                                <i className="fab fa-github" style={{ fontSize: '1.75rem' }}></i>
                            </a>
                        </div>
                    </div>

                    {/* Right Column - Image */}
                    <div className="col-md-5 text-center">
                        <img
                            src="/imgs/profile.png"
                            alt="Marc E. Canby"
                            className="img-fluid" //rounded-circle"
                            style={{
                                maxWidth: '250px',
                                borderRadius: '40px', // For rounded rectangle
                            }}
                        />
                    </div>
                </div>

                {/* About Section Below */}
                <div className="row mt-4">
                    <div className="col">
                        <h2>About Me</h2>
                        <p>
                            I am a Ph.D. candidate at the University of Illinois Urbana-Champaign.
                            I am advised by <a href="https://juliahmr.cs.illinois.edu/"> Julia Hockenmaier</a>.
                        </p>
                        <p>
                            My research interests are broadly in natural language prcoessing, with
                            a focus in large language model interpretability, multilinguality,
                            and retrieval-augmented generation. I also work on computational historical
                            linguistics, particularly phylogenetics.
                        </p>
                        <p>
                            I am an avid skier, scuba diver, and traveler.
                        </p>
                    </div>
                </div>
            </div>
            </body>
        </>
    )
}